import { render, staticRenderFns } from "./TiptapEditor.vue?vue&type=template&id=c90662d2&scoped=true"
import script from "./TiptapEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TiptapEditor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TiptapEditor.vue?vue&type=style&index=0&id=c90662d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90662d2",
  null
  
)

export default component.exports